<template>
  <div class="international-trade" :class="{ notForTecRussiaTab: notForTecRussiaTab }">
    <div class="international-trade__switch-block d-flex justify-content-between bgWhite">
      <div class="international-trade__switch">
        <RedesignedSwitchComponent
          :checked="isProductMode"
          @switchHandler="switchHand($event)"
          class="switch-back--big"
        />
      </div>
      <div class="international-trade__year-selection">
        <div class="international-trade__year-label">Источник: {{ isProductMode ? 'ФТС России' : 'Банк России' }}</div>
        <div class="international-trade__select">
          <SelectMultiComponent
            id="period"
            v-model="year"
            :options="yearList"
            placeholder="Период"
            classSelect="multiselect--green multiselect--hidden-clear"
            @select="selectChange"
          />
        </div>
        <div v-if="!isProductMode" class="international-trade__select">
          <SelectMultiComponent
            id="quartal"
            v-model="quartal"
            :options="quartals"
            placeholder="Квартал"
            classSelect="multiselect--green"
            @select="loadDataQuartal"
          />
        </div>
      </div>
    </div>

    <template v-if="!currentSummary">
      <p>Загрузка данных...</p>
    </template>

    <template v-if="currentSummary">
      <SectionTitle text="Ключевые показатели торговли" class="title title--h5 title--key-trading-indicators" />
      <TradeIndicatorsList justifyContent="start">
        <TradeIndicator
          name="Экспорт"
          :divider="divider"
          :currentValue="currentSummary?.[indicatorValue.EXPORT_VALUE]"
          :previousPercent="currentSummary?.[indicatorPreviousPercentValue.EXPORT_VALUE]"
          :isSelected="tabId === tabsID.EXPORT"
          :rating="`${currentSummary[indicatorPlaceInMarket.EXPORT]} место в рос. экспорте`"
          @click="exportMoreInfo ? selectTab(tabsID.EXPORT, 'Экспорт') : null"
        />
        <TradeIndicator
          name="Импорт"
          :divider="divider"
          :currentValue="currentSummary?.[indicatorValue.IMPORT_VALUE]"
          :previousPercent="currentSummary?.[indicatorPreviousPercentValue.IMPORT_VALUE]"
          :isSelected="tabId === tabsID.IMPORT"
          :rating="`${currentSummary[indicatorPlaceInMarket.IMPORT]} место в рос. импорте`"
          @click="importMoreInfo ? selectTab(tabsID.IMPORT, 'Импорт') : null"
        />
        <TradeIndicator
          :name="isProductMode ? 'Товарооборот' : 'Оборот услуг'"
          :divider="divider"
          :currentValue="currentSummary?.[indicatorValue.TOTAL_VALUE]"
          :previousPercent="currentSummary?.[indicatorPreviousPercentValue.TOTAL_VALUE]"
          :isSelected="tabId === tabsID.TRADE_TURNOVER"
          :rating="`${currentSummary[indicatorPlaceInMarket.TRADE_TURNOVER]} место в рос. товарообороте`"
          @click="
            turnoverMoreInfo ? selectTab(tabsID.TRADE_TURNOVER, isProductMode ? 'Товарооборот' : 'Оборот услуг') : null
          "
        />
        <TradeIndicator
          v-if="isProductMode"
          name="ННЭ"
          :divider="divider"
          :currentValue="currentSummary?.[indicatorValue.EXPORT_NON_ENERGY_VALUE]"
          :previousPercent="currentSummary?.[indicatorPreviousPercentValue.EXPORT_NON_ENERGY_VALUE]"
          :isSelected="tabId === tabsID.NON_RAW_MATERIALS"
          @click="exportNonEnergyMoreInfo ? selectTab(tabsID.NON_RAW_MATERIALS, 'Несырьевой') : exportNonEnergyMoreInfo"
        />
        <TradeIndicator
          name="Сальдо"
          :divider="divider"
          :currentValue="currentSummary?.[indicatorValue.BALANCE]"
          :previousPercent="currentSummary?.[indicatorPreviousPercentValue.BALANCE]"
          :previousValue="currentSummary?.[previousValue.BALANCE]"
          :isSelected="tabId === tabsID.BALANCE"
          @click="balanceMoreInfo ? selectTab(tabsID.BALANCE, 'Сальдо') : balanceMoreInfo"
        />
      </TradeIndicatorsList>
    </template>

    <div v-if="notForTecRussiaTab != true">
      <div v-if="tabId && graphByYear">
        <h2 class="mt-5">
          <template v-if="isProductMode">Торговля товарами</template><template v-else>Торговля услугами</template>,
          {{ dividerLabel }} $ США
        </h2>
        <div v-if="visibleLineChartFour">
          <EChartsLine
            :xData="getForeignTradeXAxis"
            :series="getForeignTradeSeries"
            :tooltipPostfix="getForeignTradeValuePostfix"
            :key="graphKey"
          />
        </div>
        <div v-if="tabId === tabsID.NON_RAW_MATERIALS">
          <EChartsLine
            :xData="graphByYear.years"
            :yData="graphByYear.data[tabsID.NON_RAW_MATERIALS]"
            lineName="Абсолютное значение"
            lineColor="#01A39D"
            valuePostfix=" млн $"
            :valueFractionDigits="0"
          />
        </div>
      </div>

      <template v-if="isProductMode && currentSummary && tabId">
        <!-- Топ 5 укрупненных групп товаров ТН ВЭД с наибольшим объемом импорта -->
        <InternationalTradeChart
          v-if="selectedTabImport && currentSummary.topEnlargedImportGroups?.length"
          title="Товарная структура импорта. Топ-5 укрупненных групп"
          nameTable="Импорт"
          typeChart="topEnlargedImportGroups"
          exportGroups="enlargedImportGroupsTotalCurrent"
          exportGroupsPrevious="enlargedImportGroupsTotalPrevious"
          topExportGroups="topEnlargedImportGroups"
          :currentSummary="currentSummary"
          :switchChartProp="switchRows.topImportGroupsTotalPrevious"
          :legendName="nameLegendInternationalTradeChart"
        />
        <!-- Топ 5 групп укрупненных групп товаров ТН ВЭД с наибольшим объемом экспорта -->
        <InternationalTradeChart
          v-if="selectedTabExport && currentSummary.topEnlargedExportGroups?.length"
          title="Товарная структура экспорта. Топ-5 укрупненных групп"
          nameTable="Экспорт"
          typeChart="topEnlargedExportGroups"
          exportGroups="enlargedExportGroupsTotalCurrent"
          exportGroupsPrevious="enlargedExportGroupsTotalPrevious"
          topExportGroups="topEnlargedExportGroups"
          :currentSummary="currentSummary"
          :switchChartProp="switchRows.topEnlargedExportGroups"
          :legendName="nameLegendInternationalTradeChart"
        />

        <InternationalTradeChart
          v-if="!selectedTabNonRawMaterials && !selectedTabImport && currentSummary.topExportCode2?.length"
          title="Топ-5 товаров экспорта (2 зн.)"
          nameTable="Экспорт"
          typeChart="topExportCode2"
          exportGroups="exportCode2TotalCurrent"
          exportGroupsPrevious="exportCode2TotalPrevious"
          topExportGroups="topExportCode2"
          :currentSummary="currentSummary"
          :switchChartProp="switchRows.tovarnayaStructureExport"
          :legendName="nameLegendInternationalTradeChart"
        />

        <InternationalTradeChart
          v-if="selectedTabNonRawMaterials && currentSummary.topExportNonEnergyCode2?.length"
          title="Товарная структура экспорта"
          nameTable="Импорт"
          typeChart="topExportNonEnergyCode2"
          exportGroups="exportNonEnergyCode2TotalCurrent"
          exportGroupsPrevious="exportNonEnergyCode2TotalPrevious"
          topExportGroups="topExportNonEnergyCode2"
          :currentSummary="currentSummary"
          :switchChartProp="switchRows.tovarnayaStructureExportSecond"
          :legendName="nameLegendInternationalTradeChart"
        />

        <InternationalTradeChart
          v-if="!selectedTabNonRawMaterials && !selectedTabExport && currentSummary.topImportCode2?.length"
          title="Топ-5 товаров импорта (2 зн.)"
          nameTable="Импорт"
          typeChart="topImportCode2"
          exportGroups="importCode2TotalCurrent"
          exportGroupsPrevious="importCode2TotalPrevious"
          topExportGroups="topImportCode2"
          :currentSummary="currentSummary"
          :switchChartProp="switchRows.tovarnayaStructureImport"
          :legendName="nameLegendInternationalTradeChart"
        />

        <template v-if="!selectedTabNonRawMaterials">
          <InternationalTradeChart
            v-if="currentSummary.topExportGroups?.length && !selectedTabImport"
            title="Топ-5 товаров экспорта (4 зн.)"
            nameTable="Экспорт"
            typeChart="topExportGroups"
            exportGroups="exportGroupsTotalCurrent"
            exportGroupsPrevious="exportGroupsTotalPrevious"
            topExportGroups="topExportGroups"
            :currentSummary="currentSummary"
            :switchChartProp="switchRows.topTovariExport"
            :legendName="nameLegendInternationalTradeChart"
          />

          <InternationalTradeChart
            v-if="currentSummary.topImportGroups?.length && !selectedTabExport"
            title="Топ-5 товаров импорта (4 зн.)"
            nameTable="Импорт"
            typeChart="topImportGroups"
            exportGroups="importGroupsTotalCurrent"
            exportGroupsPrevious="importGroupsTotalPrevious"
            topExportGroups="topImportGroups"
            :currentSummary="currentSummary"
            :switchChartProp="switchRows.topTovariImport"
            :legendName="nameLegendInternationalTradeChart"
          />
        </template>

        <InternationalTradeChart
          v-if="selectedTabNonRawMaterials && currentSummary.topExportNonEnergyGroups?.length"
          title="Топ-5 товаров экспорта"
          nameTable="Экспорт"
          typeChart="topExportNonEnergyGroups"
          exportGroups="exportNonEnergyGroupsTotalCurrent"
          exportGroupsPrevious="exportNonEnergyGroupsTotalPrevious"
          topExportGroups="topExportNonEnergyGroups"
          :currentSummary="currentSummary"
          :switchChartProp="switchRows.topTovariExportSecond"
          :legendName="nameLegendInternationalTradeChart"
        />

        <div
          v-if="
            selectedTabImport && (currentSummary?.priorityImport?.length || currentSummary?.destinationImport?.length)
          "
          class="international-trade__wrapper-line-chart"
        >
          <div v-if="currentSummary?.priorityImport?.length" class="international-trade__item-line-chart">
            <!-- Приоритетный импорт -->
            <LineChartPercent name="Приоритетный импорт" :seriesProp="getSeriesPriorityImport" />
          </div>

          <div v-if="currentSummary?.destinationImport?.length" class="international-trade__item-line-chart">
            <!-- Импорт по назначению -->
            <LineChartPercent name="Импорт по назначению" :seriesProp="getSeriesDestinationImport" />
          </div>
        </div>
      </template>

      <div class="mt-5" v-if="!isProductMode && currentSummary && currentSummary.topImportGroups?.length > 0">
        <h2>Туризм</h2>
        <EChartsVerticalBar
          formatLabel=" тыс чел"
          :valueFractionDigits="0"
          :labels="currentSummary.topImportGroups.map((item) => item.title)"
          :dataset="
            getPeriodGroupsDataset(
              currentSummary.topImportGroups,
              'Выезд российских граждан в страну, тыс чел',
              'Въезд иностранных граждан в Российскую Федерацию, тыс чел',
              { divider: 1, currentKey: 'previousValue', previousKey: 'currentValue' },
            )
          "
        />
      </div>

      <div class="mt-5" v-if="isProductMode && selectedTabExport">
        <div class="d-flex align-items-center gap-3 mb-4">
          <h2 class="mb-0">Экспортный потенциал товаров</h2>
          <CollapseButton :isShow="isExportPotentialTableOpen" @click="toggleExportPotentialTable" />
        </div>
        <TableComponent
          v-show="isExportPotentialTableOpen"
          tableClass="stockTable table-component__wrapper_center-header"
          :columns="columnsExport"
          :params="tableParams"
          :storePaths="storePathsExport"
          :isShowNumberColumn="true"
          :eventConfigs="eventConfigs"
          :showPagination="false"
          :pagination="{ size: 15 }"
        />
      </div>

      <div class="mt-5" v-if="isProductMode && selectedTabImport">
        <div class="d-flex align-items-center gap-3 mb-4">
          <h2 class="mb-0">Импортный потенциал товаров</h2>
          <CollapseButton :isShow="isExportPotentialTableOpen" @click="toggleExportPotentialTable" />
        </div>
        <TableComponent
          v-show="isExportPotentialTableOpen"
          tableClass="stockTable table-component__wrapper_center-header"
          :columns="columnsImport"
          :params="tableParams"
          :storePaths="storePathsImport"
          :isShowNumberColumn="true"
          :eventConfigs="eventConfigs"
          :showPagination="false"
          :pagination="{ size: 15 }"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { debounce } from 'lodash';

  import CollapseButton from '@/common/components/redesigned/CollapseButton.vue';
  import RedesignedSwitchComponent from '@/common/components/redesigned/RedesignedSwitchComponent.vue';
  import SectionTitle from '@/common/components/redesigned/SectionTitle/SectionTitle.vue';
  import TableComponent from '@/common/components/redesigned/Table/TableComponent.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';
  import Constants from '@/common/constants';
  import text from '@/common/mixins/text';

  import EChartsLine from '@/components/ChartComponents/apacheEcharts/EChartsLine.vue';
  import EChartsVerticalBar from '@/components/ChartComponents/apacheEcharts/EChartsVerticalBar.vue';

  import {
    COUNTRY_ANALYTICS_ACTIONS_NAME,
    COUNTRY_ANALYTICS_GETTERS_NAME,
    COUNTRY_ANALYTICS_MUTATIONS_NAME,
  } from '@/modules/countryАnalytics/store/analytics/directoryNames';

  import {
    COLOR_DESTINATION_IMPORT,
    COLOR_PRIORITY_IMPORT,
    DIVIDER_LABEL,
    TABS_ID_KEY_TRADING_INDICATORS,
  } from '../../utils/constants';
  import LineChartPercent from '../charts/LineChartPercent.vue';
  import TradeIndicator from './indicators/TradeIndicator.vue';
  import TradeIndicatorsList from './indicators/TradeIndicatorsList.vue';
  import InternationalTradeChart from './InternationalTradeChart.vue';
  import InternationalTradeMixin from './mixin/InternationalTradeMixin';
  import InternationalTradeRussiaMixin from './mixin/InternationalTradeRussiaMixin';

  export default {
    name: 'InternationalTradeRussia',
    mixins: [text, InternationalTradeMixin, InternationalTradeRussiaMixin],
    props: {
      notForTecRussiaTab: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      EChartsLine,
      EChartsVerticalBar,
      CollapseButton,
      RedesignedSwitchComponent,
      SelectMultiComponent,
      LineChartPercent,
      InternationalTradeChart,
      TradeIndicator,
      TradeIndicatorsList,
      TableComponent,
      SectionTitle,
    },
    data() {
      return {
        isProductMode: true,
        tabId: null,

        turnoverMoreInfo: true,
        exportMoreInfo: true,
        importMoreInfo: true,
        exportNonEnergyMoreInfo: true,
        balanceMoreInfo: true,

        divider: Constants.MILLION,
        dividerLabel: DIVIDER_LABEL,
        indicatorValue: Constants.indicator.value,
        previousValue: Constants.indicator.previousValue,
        indicatorPreviousPercentValue: Constants.indicator.previousPercentValue,
        indicatorPlaceInMarket: Constants.indicator.placeInMarket,

        switchRows: {
          tovarnayaStructureExport: true,
          tovarnayaStructureExportSecond: true,
          tovarnayaStructureImport: true,
          topTovariExport: true,
          topTovariImport: true,
          topTovariExportSecond: true,
          topEnlargedExportGroups: true,
          topImportGroupsTotalPrevious: true,
        },
        tabsID: TABS_ID_KEY_TRADING_INDICATORS,

        storePathsExport: {
          action: COUNTRY_ANALYTICS_ACTIONS_NAME.searchExportTable,
          mutation: COUNTRY_ANALYTICS_MUTATIONS_NAME.setExportTableData,
          getter: COUNTRY_ANALYTICS_GETTERS_NAME.getExportTableData,
        },
        storePathsImport: {
          action: COUNTRY_ANALYTICS_ACTIONS_NAME.searchImportTable,
          mutation: COUNTRY_ANALYTICS_MUTATIONS_NAME.setImportTableData,
          getter: COUNTRY_ANALYTICS_GETTERS_NAME.getImportTableData,
        },
        isExportPotentialTableOpen: false,
      };
    },
    computed: {
      tableParams() {
        return {
          toCountryId: this.countryId,
          pageNumber: 1,
          pageSize: 15,
        };
      },

      exportTableData() {
        return this.$store.getters[this.storePathsExport.getter] ?? {};
      },

      importTableData() {
        return this.$store.getters[this.storePathsImport.getter] ?? {};
      },

      columnsExport() {
        const exportYear = this.exportTableData.yearExport;
        const importYear = this.exportTableData.yearImport;

        return [
          { field: 'tnvedCode', title: 'Код ТН ВЭД ЕАЭС', textAlign: 'center' },
          { field: 'tnvedName', title: 'Наименование товара' },
          {
            field: 'potentialValue',
            title: 'Экспортный потенциал, млн долл.',
            textAlign: 'center',
            formatter: (item) => (item.potentialValue ? this.formatAdaptiveNumber(item.potentialValue) : '-'),
          },
          {
            field: 'exportFactToCountry',
            title: `Фактический экспорт России в страну, млн долл.${this.yearFormatter(exportYear)}`,
            formatter: (item) => (item.exportFactToCountry ? this.formatAdaptiveNumber(item.exportFactToCountry) : '-'),
            textAlign: 'center',
          },
          {
            field: 'exportFactWorld',
            title: `Фактический экспорт России во все страны, млн долл.${this.yearFormatter(exportYear)}`,
            formatter: (item) => (item.exportFactWorld ? this.formatAdaptiveNumber(item.exportFactWorld) : '-'),
            textAlign: 'center',
          },
          {
            field: 'importFromCountry',
            title: `Фактический импорт страны из всех стран, млн долл.${this.yearFormatter(importYear)}`,
            formatter: (item) => (item.importFromCountry ? this.formatAdaptiveNumber(item.importFromCountry) : '-'),
            textAlign: 'center',
          },
          { field: 'countryName', title: 'Страна-импортер' },
        ];
      },

      columnsImport() {
        const exportYear = this.importTableData.yearExport;
        const importYear = this.importTableData.yearImport;

        return [
          { field: 'tnvedCode', title: 'Код ТН ВЭД ЕАЭС', textAlign: 'center' },
          { field: 'tnvedName', title: 'Наименование товара' },
          {
            field: 'potentialValue',
            title: 'Импортный потенциал, млн долл.',
            formatter: (item) => (item.potentialValue ? this.formatAdaptiveNumber(item.potentialValue) : '-'),
            textAlign: 'center',
          },
          {
            field: 'importFactFromCountry',
            title: `Фактический импорт России из страны, млн долл.${this.yearFormatter(importYear)}`,
            formatter: (item) =>
              item.importFactFromCountry ? this.formatAdaptiveNumber(item.importFactFromCountry) : '-',
            textAlign: 'center',
          },
          {
            field: 'importFactWorld',
            title: `Фактический импорт России из всех стран, млн долл.${this.yearFormatter(importYear)}`,
            formatter: (item) => (item.importFactWorld ? this.formatAdaptiveNumber(item.importFactWorld) : '-'),
            textAlign: 'center',
          },
          {
            field: 'exportFactCountry',
            title: `Фактический экспорт страны в мир, млн долл.${this.yearFormatter(exportYear)}`,
            formatter: (item) => (item.exportFactCountry ? this.formatAdaptiveNumber(item.exportFactCountry) : '-'),
            textAlign: 'center',
          },
          { field: 'countryName', title: 'Страна-экспортер' },
        ];
      },

      getSeriesPriorityImport() {
        if (this.currentSummary?.priorityImport) {
          return this.currentSummary.priorityImport.map((i) => ({
            data: i.part,
            name: i.importKindName,
            color: COLOR_PRIORITY_IMPORT[i.importKindId].color,
          }));
        }
        return [];
      },

      getSeriesDestinationImport() {
        if (this.currentSummary?.destinationImport) {
          return this.currentSummary.destinationImport.map((i) => ({
            data: i.part,
            name: i.importKindName,
            color: COLOR_DESTINATION_IMPORT[i.importKindId].color,
          }));
        }
        return [];
      },

      visibleLineChartFour() {
        const arr = [this.tabsID.TRADE_TURNOVER, this.tabsID.EXPORT, this.tabsID.IMPORT, this.tabsID.BALANCE];
        return arr.includes(this.tabId);
      },

      selectedTabImport() {
        return this.tabId === this.tabsID.IMPORT;
      },

      selectedTabExport() {
        return this.tabId === this.tabsID.EXPORT;
      },

      selectedTabNonRawMaterials() {
        return this.tabId === this.tabsID.NON_RAW_MATERIALS;
      },

      nameLegendInternationalTradeChart() {
        return {
          current: `${this.summary.summary.chartPeriodNames.current}, ${this.dividerLabel} $`,
          previous: `${this.summary.summary.chartPeriodNames.previous}, ${this.dividerLabel} $`,
        };
      },
    },
    created() {
      this.loadIndicatorVisibility();
      this.loadYearList(true, true);

      if (!this.isProductMode) {
        this.loadQuartals();
      }
    },
    methods: {
      yearFormatter(year) {
        return year ? ` (${year})` : '';
      },
      toggleExportPotentialTable() {
        this.isExportPotentialTableOpen = !this.isExportPotentialTableOpen;
      },
      selectTab(id, label) {
        if (id != this.tabId) {
          this.tabId = id;
          this.label = label;
          this.isExportPotentialTableOpen = false;
          this.loadData();
        } else {
          // при повторном клике - сворачивание
          this.tabId = null;
          this.label = null;
          this.isExportPotentialTableOpen = false;
        }
      },
      selectChange: debounce(function () {
        this.clearGraph();
        this.loadData();

        if (!this.isProductMode) {
          this.loadQuartals();
        }
      }, 500),
      getPeriodGroupsDataset(groups, currentLabel, previousLabel, options = {}) {
        const { divider = 1, fractionDigits = 0, currentKey = 'currentValue', previousKey = 'previousValue' } = options;

        return [
          {
            label: currentLabel,
            data: groups.map((item) => Number((item[currentKey] / divider).toFixed(fractionDigits))),
            color: '#04b1e0',
          },
          {
            label: previousLabel,
            data: groups.map((item) => Number((item[previousKey] / divider).toFixed(fractionDigits))),
            color: '#00C6A2',
          },
        ];
      },
    },
  };
</script>

<style scoped lang="scss">
  @import './src/assets/theme/default/colors';
  @import './styles/InternationalTradeRussia.scss';
  @import '@/assets/theme/default/title.scss';
  @import '../../styles/indicators-wrap.scss';
</style>
